var map = {
	"./bingbao.png": "c6df",
	"./lei.png": "5b44",
	"./qing.png": "41a6",
	"./shachen.png": "0c5e",
	"./wu.png": "d38f",
	"./xue.png": "b801",
	"./yin.png": "5a1d",
	"./yu.png": "9a16",
	"./yun.png": "a6b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "daa8";